import { createSlice } from "@reduxjs/toolkit";
import {
  carerAction,
  careseekerlist,
  careseekerlistinfo,
  carersAvailability,
  getprofiledetail,
} from "../Action/CareSeekerAction";

const CareSeeker = createSlice({
  name: "CareSeeker",
  initialState: {
    careseekerArr: [],
    careseekerlistData: [],
    getprofiledetail: {},
    carerlist: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(careseekerlist.fulfilled, (state, action) => {
        state.careseekerArr = action.payload;
      })

      .addCase(careseekerlistinfo.fulfilled, (state, action) => {
        state.careseekerlistData = action.payload;
      })

      .addCase(getprofiledetail.fulfilled, (state, action) => {
        state.getprofiledetail = action.payload;
      })
      .addCase(carerAction.fulfilled, (state, action) => {
        state.carerlist = action.payload;
      })
      .addCase(carersAvailability.fulfilled, (state, action) => {
        state.carerlist = action.payload || [];
      });
  },
});

export default CareSeeker.reducer;
